/**
 *
 */
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Icon, message as Message, Tooltip, Popconfirm } from 'antd'
import { push } from 'react-router-redux'
import { appAccountLoad, appAccountClose } from '../actions/cuenta'
import { ToggleTheme } from '.'
import Api from '../Api'
import { buildPath } from '../Routes'
import Exception from '../Exception'
import { inDev } from '../Env'

/**
 *
 * @returns
 */
function buildAccessItems() {
  const result = {
    dashboard: {
      title: 'INICIO',
      path: '/',
      icon: 'flag',
    },

    cotizaciones: {
      title: 'COTIZACIONES',
      path: '/com/cotizaciones',
      icon: 'shop', //icon: 'shopping-cart',
    },

    entregas: {
      title: 'PROGRAMA DE ENTREGAS',
      path: '/com/entregas',
      icon: 'calendar',
    },

    entradas: {
      title: 'ENTRADAS DE COMPRA',
      path: '/alm/entradas',
      icon: 'inbox',
    },

    pagosSolicitados: {
      title: 'SOL. DE PAGO, MATERIALES, SERV EN GRAL., SUB CONTRATOS, RENTAS',
      path: '/cxp/pagos-solicitados',
      icon: 'build',
    },

    pagos: {
      title: 'PAGOS PROGRAMADOS Y APLICADOS',
      path: '/cxp/pagos-programados',
      icon: 'bank',
    },

    subContratos: {
      title: 'SUB-CONTRATOS Y ESTIMACIONES',
      path: '/sub/contratos',
      icon: 'number',
    },

    rentaEquipos: {
      title: 'FACTURAS DE MAQUINARIA Y EQUIPOS',
      path: '/com/control-rentas',
      icon: 'dashboard',
    },

    complementsPago: {
      title: 'COMPLEMENTOS DE PAGO',
      path: '/com/complementos-pago',
      icon: 'file-done',
    }
  }

  return result
}

/**
 *
 * @param {*} model
 * @param {*} fieldName
 * @param {*} opts
 * @returns
 */
function buildQueryObj(model, fieldName, opts = {}) {
  return {
    model: model,
    attributes: ['iId'],
    include: opts.include || undefined,
    where: {
      [fieldName]: {
        $ne: null,
        $eq: Api.getProviderId(),
      },
      iActivo: true,
      ...opts.where,
    },
    limit: 1,
  }
}

/**
 *
 * @returns
 */
function buildQueryList() {
  const result = {
    // cotizaciones: buildQuery('ComCuadroComparativoProveedor', 'iIdProveedor'),
    ordenes: buildQueryObj('ComOrden', 'iId_proveedor'),
    ordenesMat: buildQueryObj('ComOrden', 'iId_proveedor', {
      where: { sConsecutivo: { $notLike: 'OS%' } }
    }),

    entradas: buildQueryObj('AlmEntrada', 'iId_Proveedor'),

    ordenesMaq: buildQueryObj('ComOrden', 'iId_proveedor', {
      include: [{
        as: 'requisicion',
        required: true,
        attributes: [],
        where: {
          iActivo: true,
          iMaquinaria: true,
        },
      }]
    }),

    subContratos: buildQueryObj('CmrProject', 'iIdSubContratista'),

    pagos: buildQueryObj('TesPago', 'iIdProveedor'),
  }

  return result
}

/**
 *
 * @returns
 */
function buildSidebarAccessList() {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await Api.query.list(buildQueryList())
      const items = buildAccessItems()
      const sidebar = [items.dashboard]

      // cotizaciones
      // if (data.cotizaciones.length) { sidebar.push(this.cotizaciones) }
      // ordenes de compra o servicio
      if(data.ordenesMat.length) { sidebar.push(items.entregas) }
      // entradas
      if(data.entradas.length) { sidebar.push(items.entradas) }
      // ordenes de maquinaria
      if(data.ordenesMaq.length) { sidebar.push(items.rentaEquipos) }
      // sub contratos
      if(data.subContratos.length) { sidebar.push(items.subContratos) }
      // pagos solicitados
      if(data.ordenes.length) { sidebar.push(items.pagosSolicitados) }
      // pagos (programados y aplicados)
      if(data.pagos.length) { sidebar.push(items.pagos) }
      // complementos de pago
      sidebar.push(items.complementsPago)
      resolve(sidebar)
    } catch (err) {
      reject(err)
    }
  })
}

/**
 *
 */
class Sidebar extends React.Component {
  /**
   *
   * @param {*} props
   */
  constructor(props) {
    super(props)

    this.state = {
      loginVisible: false,
      modules: [buildAccessItems().dashboard],
    }
  }

  /**
   *
   */
  checkAccess = () => {
    const self = this
    buildSidebarAccessList()
      .then(sidebar => self.setState({ modules: sidebar }))
      .catch(err => Exception.load(err).show())
  }

  /**
   *
   */
  componentDidMount = () => {
    const self = this
    if (this.props.Cuenta) {
      if (this.props.Cuenta.needsChangePassword) {
        Message.warning('Debe renovar su contraseña para continuar')
        this.props.To('/preferencias')
      } else {
        this.props.CargarCuenta(() => self.checkAccess())
      }
    } else {
      this.props.CargarCuenta(() => self.checkAccess())
    }
  }

  /**
   *
   * @param {*} text
   */
  buscar = (text) => {
    if (text.length > 0)
      Message.loading(`Buscando: ${text}`, 2)
  }

  /**
   * Render
   *
   */
  render = () => {
    const { styles } = this.props
    const currentPath = window.location.pathname
    const modules = this.state.modules

    return (
      <div style={styles.root}>
        <div style={styles.content}>
          <div style={styles.logo}>
            <Link to={buildPath('/')}>
              <img
                alt='app'
                width={40}
                style={{ borderRadius: 4 }}
                src={inDev ? '/app.png' : Api.to('/cmr/organizacion/image-file/bIconoWebSidebar')}
              />
            </Link>
          </div>

          <div style={styles.links}>
            {modules.map((module, idx) =>
              <div key={idx.toString()} style={styles.link}>
                <Link to={buildPath(module.path)} className={`hoverable ${currentPath === module.path ? 'active' : ''}`.trim()}>
                  <Tooltip title={module.title} placement='right'>
                    <Icon type={module.icon} style={{ fontSize: 28 }} />
                  </Tooltip>
                </Link>
              </div>
            )}
          </div>

          <div style={styles.footer}>
            <div style={styles.link}>
              <Tooltip title='Modo nocturno' placement='right'>
                <ToggleTheme />
              </Tooltip>
            </div>

            <div style={styles.link}>
              <Link to={buildPath('/preferencias')} className={`hoverable ${currentPath === 'perfil' ? 'active' : ''}`.trim()}>
                <Tooltip title='Preferencias' placement='right'>
                  <Icon type='setting' style={{ fontSize: 28 }} />
                </Tooltip>
              </Link>
            </div>

            <Popconfirm title='¿Cerrar sesión?' onConfirm={() => this.props.CerrarSesion()} placement='right' okText='Cerrar sesión'>
              <div style={{...styles.link, cursor: 'pointer'}}>
                <Tooltip title='Cerrar sesión' placement='right'>
                  <Icon type='logout' style={{ fontSize: 28 }} />
                </Tooltip>
              </div>
            </Popconfirm>
          </div>
        </div>
      </div>
    )
  }
}

const buildStyles = theme => ({
  root: {
    background: theme.colors.panel,
    display: 'flex',
    flex: 1,
    paddingTop: 7,
    paddingBottom: 7,
    paddingLeft: 3,
    paddingRight: 3,
    flexDirection: 'column',
    alignItems: 'center',
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
  },

  logo: {
    marginBottom: 75,
  },

  links: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 15,
  },

  link: {
    padding: 5,
    marginBottom: 15,
  },

  footer: {
    alignSelf: 'flex-end',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  }
})

export default connect(
  state => ({
    theme: state.theme.values,
    Cuenta: state.cuenta,
    styles: buildStyles(state.theme.values),
  }),
  dispatch => ({
    CargarCuenta: (cb) => dispatch(appAccountLoad(cb)),
    CerrarSesion: () => {
      dispatch(appAccountClose())
      dispatch(push(buildPath('/')))
    },
    To: (path) => dispatch(push(path))
  })
)(Sidebar)
